export const FLAGS = { SK: "🇸🇰", CZ: "🇨🇿", PL: "🇵🇱", HU: "🇭🇺" };

export function formatPrice(value, currency = "EUR") {
  if (value == null) return "—";
  return new Intl.NumberFormat("de-DE", { style: "currency", currency }).format(value);
}

export function stockLabel(status, t) {
  const map = {
    in_stock: { label: t("product.instock"), cls: "text-emerald-600 bg-emerald-50 border-emerald-200" },
    low_stock: { label: t("product.lowstock"), cls: "text-amber-600 bg-amber-50 border-amber-200" },
    backorder: { label: t("product.backorder"), cls: "text-slate-500 bg-slate-100 border-slate-200" },
  };
  return map[status] || map.in_stock;
}
